import MenuItem from '@material-ui/core/MenuItem';
import DatePicker from 'components/DatePicker/DatePicker';

import CustomInput, { Props as CustomInputProps } from '../../../../components/CustomInput/CustomInput';
import Country from '../../../../types/Country';
import { FlexContainer } from './styled';

interface Props {
    baseInputProps: Omit<CustomInputProps, 'name'>;
    countries: Country[];
    isNewCompany: boolean;
}

const Form = (props: Props) => {
    const { baseInputProps, countries, isNewCompany } = props;

    return (
        <>
            <FlexContainer>
                <CustomInput {...baseInputProps} name='name' />
                <CustomInput {...baseInputProps} name='email' />
            </FlexContainer>

            <FlexContainer>
                <CustomInput {...baseInputProps} name='website' />
                <CustomInput {...baseInputProps} name='vatCode' />
            </FlexContainer>

            <FlexContainer>
                <CustomInput {...baseInputProps} name='address' />
                <CustomInput {...baseInputProps} name='city' />

                <CustomInput {...baseInputProps} name='countryId' select >
                    {countries.map(country => {
                        return (
                            <MenuItem key={country.id} value={country.id}>
                                {country.name}
                            </MenuItem>
                        );
                    })}
                </CustomInput>
            </FlexContainer>

            {(isNewCompany || true) && (
                <DatePicker {...baseInputProps} name='certificationStartDate' />
            )}

            <FlexContainer>
                <CustomInput {...baseInputProps} name='phoneOffice' />
                <CustomInput {...baseInputProps} name='phoneMobile' />
            </FlexContainer>

            <CustomInput {...baseInputProps} name='note' rows={5} multiline />
        </>
    );
};

export default Form;
